import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import AutocaptureConfig from '../../product-analytics/_snippets/multilanguage/autocapture-config.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In web apps using the `}<a parentName="p" {...{
        "href": "/docs/libraries/js"
      }}>{`JavaScript Web SDK`}</a>{`, the following data can be autocaptured.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Feature`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Data captured`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Product analytics`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pageviews, pageleaves, clicks, changes of inputs, and form submissions associated with `}<inlineCode parentName="td">{`<a>`}</inlineCode>{`, `}<inlineCode parentName="td">{`<button>`}</inlineCode>{`, `}<inlineCode parentName="td">{`<form>`}</inlineCode>{`, `}<inlineCode parentName="td">{`<input>`}</inlineCode>{`, `}<inlineCode parentName="td">{`<select>`}</inlineCode>{`, `}<inlineCode parentName="td">{`<textarea>`}</inlineCode>{`, and `}<inlineCode parentName="td">{`<label>`}</inlineCode>{` tags`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Web analytics`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pageviews, pageleaves, conversions, and `}<a parentName="td" {...{
              "href": "https://github.com/GoogleChrome/web-vitals"
            }}>{`web vitals`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Session replay`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Clicks, mouse movements, scrolling, and snapshots of the DOM`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Error tracking`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Exceptions thrown in the browser using `}<inlineCode parentName="td">{`onError`}</inlineCode>{` and `}<inlineCode parentName="td">{`onUnhandledRejection`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`You can control autocapture using the `}<inlineCode parentName="p">{`autocapture`}</inlineCode>{` option in the `}<inlineCode parentName="p">{`posthog.init`}</inlineCode>{` call.`}</p>
    <p>{`You can disable autocapture entirely by setting `}<inlineCode parentName="p">{`autocapture`}</inlineCode>{` to `}<inlineCode parentName="p">{`false`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`posthog.init('<ph_project_api_key>', {
    api_host: '<ph_client_api_host>',
    autocapture: false,
})
`}</code></pre>
    <p>{`You can also control what is captured using the `}<inlineCode parentName="p">{`AutocaptureConfig`}</inlineCode>{` object.`}</p>

    <AutocaptureConfig mdxType="AutocaptureConfig" /> 

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      